import { FunctionComponent } from 'react';
import { Stack, Typography } from '@mui/material';
import { ChildTenant, ChildTenantAccessUser } from '../../../@types/organization';
import { useTranslator } from 'translation/useTranslator';

interface ChildTenantAccessRemoveProps {
  childTenant: ChildTenant;
  accessUser: ChildTenantAccessUser;
}

const ChildTenantAccessRemove: FunctionComponent<ChildTenantAccessRemoveProps> = ({
  childTenant,
  accessUser
}) => {
  const translator = useTranslator();

  return (
    <Stack spacing={2}>
      <Typography variant="body2">
        {translator.removeChildTenantAccessDescription(
          accessUser.name || accessUser.email,
          childTenant.name
        )}
      </Typography>
    </Stack>
  );
};

export default ChildTenantAccessRemove;
